<template>
	<div class="main">
		<div v-for="(item,index) in officeList" :key="index" class="office">
			<el-image fit="fill" class="officeImg" :src="item" :preview-src-list="officeList"></el-image>
		</div>
	</div>
</template>

<script>
export default {
	name: "Office",
	data() {
		return {
			baseImgUrl: process.env.VUE_APP_IMGURL,
			officeList: []
		}
	},
	mounted() {
		this.$api.get('about/getOffice').then(res => {
			let l = [];
			for(let i=0; i<res.length; i++){
				l[i] = this.baseImgUrl + res[i];
			}
			this.officeList = l;
		});
	}
}
</script>

<style scoped>
@media (max-width: 500px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 100%; height: 220px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 220px; }
}
@media (min-width: 500px) and (max-width: 726px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 48%; height: 220px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 220px; }
}
@media (min-width: 726px) and (max-width: 999px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 48%; height: 230px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 230px; }
}
@media (min-width: 999px) and (max-width: 1251px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 31%; height: 240px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 240px; }
}
@media (min-width: 1252px) and (max-width: 1845px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 24%; height: 250px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 250px; }
}
@media (min-width: 1846px) and (max-width: 2200px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 24%; height: 260px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 260px; }
}
@media (min-width: 2201px){
	.main{ width: 100%; padding: 30px 0 20px 0; display: flex; flex-wrap: wrap; justify-content: flex-start; }
	.office{ width: 19%; height: 280px; margin: 0 1% 18px 0; animation: rollIn; animation-duration: 1.5s; }
	.officeImg{ width: 100%; height: 280px; }
}
</style>